import { Observer, } from '../../../core/observer/implementation';
import { NOTIFICATIONS_OBSERVER_PRIVATE } from './privates';
import { ConstructNotificationsObserver } from './constructor';
export function NotificationsObserverEmit(instance, notification) {
    const privates = instance[NOTIFICATIONS_OBSERVER_PRIVATE];
    if (notification.name === privates.name) {
        privates.callback.call(instance, notification.value);
    }
}
export function NotificationsObserverMatches(instance, name, callback) {
    const privates = instance[NOTIFICATIONS_OBSERVER_PRIVATE];
    return (privates.name === name)
        && ((callback === void 0)
            || (privates.callback === callback));
}
export function NotificationsObserverGetName(instance) {
    return instance[NOTIFICATIONS_OBSERVER_PRIVATE].name;
}
export function NotificationsObserverGetCallback(instance) {
    return instance[NOTIFICATIONS_OBSERVER_PRIVATE].callback;
}
export class NotificationsObserver extends Observer {
    constructor(name, callback) {
        super((notification) => {
            NotificationsObserverEmit(this, notification);
        });
        ConstructNotificationsObserver(this, name, callback);
    }
    get name() {
        return NotificationsObserverGetName(this);
    }
    get callback() {
        return NotificationsObserverGetCallback(this);
    }
    matches(name, callback) {
        return NotificationsObserverMatches(this, name, callback);
    }
}
//# sourceMappingURL=implementation.js.map